import UserAvatar from "Areas/SharedFeatures/userAvatar";
import { MenuToggler } from "Components/menuGeneric";
import isEmpty from "lodash/isEmpty";
import React, { useEffect } from "react";
export default function ProfileToggler(props) {
    var _a, _b, _c, _d;
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, []);
    return (React.createElement(MenuToggler, { onClick: props.onClick, className: props.className, id: props.id, size: 40 },
        React.createElement(UserAvatar, { userId: props.user.Id, login: (_a = props.user) === null || _a === void 0 ? void 0 : _a.Login, firstName: (_b = props.user) === null || _b === void 0 ? void 0 : _b.FirstName, lastName: (_c = props.user) === null || _c === void 0 ? void 0 : _c.LastName, fullName: (_d = props.user) === null || _d === void 0 ? void 0 : _d.FullName, isNewUser: isEmpty(props.user), size: "100%" })));
}
